import BulkOrder from "./BulkOrder"

const BulkOrderContainer = () =>{
    return(
        <BulkOrder/>
    )
}
export default BulkOrderContainer